import { render, staticRenderFns } from "./TheSettingsList.vue?vue&type=template&id=729d7bf0&scoped=true"
import script from "./TheSettingsList.vue?vue&type=script&lang=ts"
export * from "./TheSettingsList.vue?vue&type=script&lang=ts"
import style0 from "./TheSettingsList.vue?vue&type=style&index=0&id=729d7bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729d7bf0",
  null
  
)

export default component.exports